

<template>
  <div>
    <CRow>
      <CCol sm="12">
          <CCard>
            <CCardHeader>
              <CIcon name="cil-grid"/> 問題管理
              <div class="card-header-actions">
                <a
                  class="card-header-action"
                  rel="noreferrer noopener"
                  target="_blank"
                >
                  <CButton size="sm" class="mr-2" color="dark" @click="showRecordModal()">編集</CButton>
                  <CButton size="sm" color="danger"  @click="deleteModal = true">削除</CButton>
                </a>
              </div>
            </CCardHeader>
            <CCardBody>
              <CCol md="8" class="offset-md-2">
                <dl v-for="(k, v) in labelDic" class="row" :key="v">
                  <dt class="col-sm-3">{{k}}</dt>
                  <dd class="col-sm-9">
                    <div v-if="v=='content'">
                       <p v-if="record.question_type == 'true_or_false'">--</p>
                       <div v-if="record.question_type != 'true_or_false'">
                         <CInput
                            v-for="(k, v) in record[v]"
                            :key="v"
                            type="text"
                            disabled="true"
                            :prepend="'選択肢' + (v+1)"
                            class="answer-form"
                            v-model="k.label"
                         >
                            <template #append-content>
                            </template>
                         </CInput>
                       </div>
                    </div>
                    <div v-else-if="v=='photos'">
                      <div v-if="record[v] != undefined">
                        <div v-for="src in record[v].split(',')" :key="src">
                          <img class="w-100" :src="src"/>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      {{formatData(v, record[v])}}
                    </div>
                  </dd>
                </dl>
              </CCol>
            </CCardBody>
          </CCard>
      </CCol>
    </CRow>

    <question-modal :mode="mode" :record="record" :recordModal="recordModal" @hide="hideRecordModal()" :industryTypes="industryTypes"></question-modal>

    <CModal
      title="削除しますか？"
      color="danger"
      :show.sync="deleteModal"
    >
      <div class="text-center">
        <p>この業種を削除しますか？？</p>
        <p>削除してしまうと復元することはできません</p>
      </div>
      <template #footer>
        <CButton size="sm" @click="hideDeleteModal()">キャンセル</CButton>
        <CButton size="sm" color="danger" @click="deleteItem()">削除</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import QuestionModal from "../../components/QuestionModal";
import { required } from "vuelidate/lib/validators";
import { mapGetters } from 'vuex';
export default {
  name: 'Home',
  components: {QuestionModal},
  data() {
    return {
      recordModal: false,
      deleteModal: false,
      record: {},
      options: {},
      mode: "Edit",
      labelDic: {
          "id": "ID",
          "title": "問題文",
          "question_type": "問題の種別",
          "industry_id": "業種",
          "content": "問題内容",
          "answer": "回答",
          "photos": "問題画像",
          "commentary": "解説",
          "created_at": "作成日",
          "updated_at": "更新日"
      },
      questionTypeLabel: {
          "true_or_false": "丸ばつ問題",
          "radio": "単数選択式",
          "checkbox": "複数選択式",
      },
      questionTypes: [
         {
            value: "radio",
            label: "単数選択式"
         },
         {
            value: "checkbox",
            label: "複数選択式"
         }
      ],
      industryTypes: [],
      industryLabel: {}
    }
  },
  validations: {
    record: {
      title: {required},
      question_type: {required},
      industry_id: {required},
      commentary: {required}
    }
  },
  methods: {
    formatData: function(label, d) {
        if(label == "created_at" || label == "updated_at") {
          return moment(d).format("YYYY/MM/DD HH:mm")
        } else if(label == "question_type") {
          return this.questionTypeLabel[d]
        } else if(label == "industry_id") {
          return this.industryLabel[parseInt(d)]
        } else if(label == "answer") {
          if(this.record.question_type == "radio") {
            return "選択肢"  + (parseInt(d) + 1)
          } else {
            return d
          }
        } else {
          return d
        }
    },
    hideRecordModal: function() {
      this.recordModal = false
    },
    updateItem: function() {
      axios
        .patch(process.env.VUE_APP_API_ENDPOINT + "/questions/" + this.record.id, {"question": this.record}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(() => {
          this.recordModal = false
        }).catch(error => {
          console.log(error)
        })
    },
    showRecordModal: function(mode="Edit") {
      this.recordModal = true
      if(mode == "Edit") {
        this.options = this.record.content
      }
      this.mode = mode
    },
    deleteItem: function() {
      axios
        .delete(process.env.VUE_APP_API_ENDPOINT + "/questions/" + this.record.id, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(() => {
          this.deleteModal = false
          this.$router.push('/questions')

        }).catch(error => {
          console.log(error)
        })
    }
  },
  mounted() {
    axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/questions/" + this.$route.params.id, {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
          this.record = response.data
          console.log(this.record)
          this.record.content = JSON.parse((this.record.content || "{}"))
          if(this.record.question_type == 'radio') {
            this.record.content.forEach((k) => {
              this.options[k.label] = (k.is_answer == "true")
            })
          }
          console.log(this.options)
      }).catch(error => {
          console.log(error)
      })

    axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/industries", {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
          response.data.industries.forEach((i) => {
            this.industryLabel[i.id] = i.name
            this.industryTypes.push({
                value: i.id,
                label: i.name
            })
          })
          console.log(this.industryTypes)
      }).catch(error => {
          console.log(error)
          this.errorNotify(error.response)
      })
  },
  computed: {
    ...mapGetters({
      idToken:'GetIdToken',
    })
  },
}
</script>
